// Turbo の page refresh(turbo_stream_from の broadcast_refresh / 同一URLへの replace visit)で、
// レイアウト内側のスクロールコンテナ(data-scroll-container)とサイドバー(SimpleBar)のスクロール位置、
// およびサイドバーで手動展開したメニューの開閉状態を維持する。
//
// 背景: このアプリは window ではなく内側の div がスクロール主体のため、Turbo 標準の
// <meta name="turbo-refresh-scroll" content="preserve"> では位置が復元されない(window.scrollY が常に 0)。
// morph 方式はサイドバーの SimpleBar やメニュー展開状態を壊すため採用せず、replace + 本スクリプトで補う。
//
// 対象は「現在と同じ URL(pathname + search)への visit」だけで、通常のページ遷移では保存しない。
// ページ側で turbo-refresh-scroll=preserve を宣言している場合のみ動作する。
//
// 復元タイミング: turbo:load 後の requestAnimationFrame。data-simplebar 属性による
// SimpleBar の初期化と simplebar の MutationObserver(マイクロタスク)が済んだ後に復元する。

const SCROLL_TARGETS = [
  "[data-scroll-container]",
  "#layout-sidebar .simplebar-content-wrapper",
]
const SIDEBAR_TOGGLE_SELECTOR = "#layout-sidebar input[type=checkbox]"

let saved = null

function preserveEnabled() {
  return !!document.querySelector('meta[name="turbo-refresh-scroll"][content="preserve"]')
}

function urlKey(url) {
  try {
    const u = new URL(url, window.location.origin)
    return u.pathname + u.search
  } catch {
    return null
  }
}

function collectState() {
  const positions = SCROLL_TARGETS.map((selector) => {
    const el = document.querySelector(selector)
    return { selector, top: el ? el.scrollTop : null }
  })
  // サイドバーの展開状態(checkbox)。復元後に自動で開くのは現在地メニューだけなので、手動で開いた分を戻す。
  // aria-label は重複する(「アカウントカテゴリー」が複数メニューにある)ため、同一ページ再描画で不変な DOM 順のインデックスをキーにする
  const toggles = Array.from(document.querySelectorAll(SIDEBAR_TOGGLE_SELECTOR))
    .map((el, index) => (el.checked ? index : null))
    .filter((index) => index !== null)
  return { positions, toggles }
}

function restoreState(state) {
  state.positions.forEach(({ selector, top }) => {
    if (top == null) return
    const el = document.querySelector(selector)
    if (el) el.scrollTop = top
  })
  const toggles = document.querySelectorAll(SIDEBAR_TOGGLE_SELECTOR)
  state.toggles.forEach((index) => {
    const el = toggles[index]
    if (el && !el.checked) el.checked = true
  })
}

document.addEventListener("turbo:before-visit", (event) => {
  const key = urlKey(event.detail.url)
  saved = preserveEnabled() && key === urlKey(window.location.href) ? { key, state: collectState() } : null
})

document.addEventListener("turbo:before-render", () => {
  // 同一 URL への refresh のみ saved が入っている。描画直前(旧 body)で取り直して最新状態にする
  if (saved) saved = { key: saved.key, state: collectState() }
})

document.addEventListener("turbo:load", (event) => {
  if (!saved) return
  const { key, state } = saved
  saved = null
  // 戻る/進む(restore visit)は turbo:before-visit を通らないため、URL が一致するときだけ復元する
  if (key !== urlKey(event.detail.url)) return
  requestAnimationFrame(() => restoreState(state))
})
